import React, { useState, useEffect } from "react";
import "../InvestmentFrequency/InvestmentFrequency.modules.css";
import Conservative from "../../../../../assets/images/Sharjah/Onboarding/5.png";
import Negligible from "../../../../../assets/images/Sharjah/Onboarding/6.png";
import Moderate from "../../../../../assets/images/Sharjah/Onboarding/7.png";
import Aggressive from "../../../../../assets/images/Sharjah/Onboarding/8.png";
import { useTranslation } from "react-i18next";
import * as Helpers from "../../../../../global/Helpers";
import i18next from "i18next";

function RiskTolerance(props) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("");
  const handleClick = (value) => {
    setSelected(value);
  };

  useEffect(() => {
    ;
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    ;
    if (selected === "") {
      Helpers.errorNotify(t("Please fill your risk tolerance"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }
    return true;
  }

  const saveKycDataFun = () => {
    ;
    if (!validateSubmit()) return;

                var result = Helpers.getScreenIdByGroupAndName("risk tolerance");
    
    var Items = [
      { ID: "35", Value: selected },
      { ID: "258", Value: "1" },
      { ID: "288", Value: result?.GROUP_ID || "" },
      { ID: "287", Value: result?.SCREEN_ID || "" },
    ];
    props.saveKycDataAPI(Items);
  };

  return (
    <div className="InvestmentFrequency-container" style={{ marginTop: "45px" }}>
      {/* <h2>What is your risk tolerance?
      </h2> */}

      <div className="button-group" style={{ justifyContent: "center" }}>
        <button
          style={{ padding: "0", height: "230px", marginInline: "10px" }}
          className={`frequency-button ${selected === "1" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("1");
          }}>
          <div style={{ display: "flow", width: "100%" }}>
            <img src={Negligible} />
            <div>{t("Negligible")} </div>
          </div>
        </button>
        <button
          style={{ padding: "0", height: "230px" }}
          className={`frequency-button ${selected === "2" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("2");
          }}>
          <div style={{ display: "flow", width: "100%" }}>
            <img src={Conservative} />
            <div> {t("Conservative")}</div>
          </div>
        </button>
      </div>

      <div className="button-group" style={{ justifyContent: "center", marginTop: "10px" }}>
        <button
          style={{ padding: "0", height: "230px", marginInline: "10px" }}
          className={`frequency-button ${selected === "3" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("3");
          }}>
          <div style={{ display: "flow", width: "100%" }}>
            <img src={Moderate} />
            <div> {t("Moderate")}</div>
          </div>
        </button>
        <button
          style={{ padding: "0", height: "230px" }}
          className={`frequency-button ${selected === "4" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("4");
          }}>
          <div style={{ display: "flow", width: "100%" }}>
            <img src={Aggressive} />

            <div> {t("Aggressive")}</div>
          </div>
        </button>
      </div>
    </div>
  );
}

export default RiskTolerance;
